import React from "react";
import "./MediaUploadCard.scss";

import Thumbnail from "components/Thumbnail";
import Input from "components/Input";
import Textarea from "components/Textarea";
import Button from "components/Button";

import ProgressBar from "components/ProgressBar";

const MediaUploadCard = ({
  image,
  title,
  description,
  onChange,
  onClickDelete,
  index,
  progress
}) => (
  <div className="MediaUploadCard">
    <div className="thumbContainer">
      <Thumbnail image={image} height={240} />
      <Button id={`delete-${index}`} onClick={onClickDelete} type="primary">
        Delete
      </Button>
      <ProgressBar progress={progress} color={"#f7941f"} />
    </div>
    <div className="content">
      <Input
        type="text"
        label="Title"
        required
        name={`title-${index}`}
        onChange={onChange}
        value={title}
        placeholder="Write a title for your project"
      />
      <Textarea
        onChange={onChange}
        value={description}
        name={`description-${index}`}
        label="Description"
      />
    </div>
  </div>
);

export default MediaUploadCard;
